import { CompanyProfileOnboarding } from '@/types/onboarding'
import { create } from 'zustand'
interface OnboardingStore {
  companyProfile: CompanyProfileOnboarding | null
  setCompanyProfileOnboarding: (val: CompanyProfileOnboarding | null) => void
  setCompanyProfileField: (val: Partial<CompanyProfileOnboarding>) => void
}

const initialValue = {
  companyProfile: null,
}
export const useOnboardingStore = create<OnboardingStore>((set) => ({
  ...initialValue,
  setCompanyProfileOnboarding: (val) => set(() => ({ companyProfile: val })),
  setCompanyProfileField: (val) =>
    set((state) => {
      const defaultVal = {
        branches: [],
        categories: [],
        name: '',
        size: '',
        website: '',
        includedUserCount: 0,
        includedWaCount: 0,
        billingCycle: 'MONTH' as const,
      }
      const safeData = state?.companyProfile || defaultVal
      return { companyProfile: { ...safeData, ...val } }
    }),
}))
